import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-foreground-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-bug-line text-2xl text-primary-400"></i>
              </div>
              <span className="text-xl font-heading text-white">虫虫动漫</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              虫虫动漫是一个免费在线漫画阅读平台，提供韩漫、日漫、国漫分类浏览，下拉式流畅阅读体验，让每一位漫画爱好者都能享受阅读乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">漫画分类</h4>
            <div className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <Link
                  key={cat.key}
                  to={`/category/${cat.key}`}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速链接</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
              <Link to="/category/hanman" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">韩漫推荐</Link>
              <Link to="/category/riman" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">日漫推荐</Link>
              <Link to="/category/guoman" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">国漫推荐</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 text-sm text-foreground-300">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line"></i>
                </div>
                <span>contact@chongchongmanhua.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-300">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-customer-service-2-line"></i>
                </div>
                <span>在线客服：工作日 9:00-18:00</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-600/20">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 虫虫动漫 ChongChongManHua. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}